import { Route } from '@angular/router';
import { redirectDashboardIfAuthenticated,  redirectLoginIfNotAuthenticated } from '@kanek/data-access';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component'),
    canActivate: [redirectDashboardIfAuthenticated()],
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/forgot-password/forgot-password.component'),
    canActivate: [redirectDashboardIfAuthenticated()],
  },
  {
    path: '',
    loadComponent: () => import('../app/features/layout/layout.component'),
    canActivate: [redirectLoginIfNotAuthenticated()],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('../app/features/dashboard/dashboard.component'),
      },
      {
        path: 'stats',
        loadComponent: () => import('../app/features/campaigns/stats.component'),
      },
      {
        path: 'contact',
        loadComponent: () => import('../app/features/campaigns/contact.component'),
      },
      {
        path: 'heat-map',
        loadComponent: () => import('../app/features/campaigns/heat-map.component'),
      },
      {
        path: 'code-delivery',
        loadComponent: () => import('../app/features/code-generation/code-delivery.component'),
      },
      {
        path: 'signage-details',
        loadComponent: () => import('../app/features/code-generation/signage-details.component'),
      },
      {
        path: 'file-upload',
        loadComponent: () => import('../app/features/file-upload/file-upload.component'),
      },
      {
        path: 'prize-list',
        loadComponent: () => import('../app/features/file-upload/prize-list.component'),
      },
      {
        path: 'account',
        loadComponent: () => import('../app/features/account/account.component'),
      },
      {
        path: 'authorize-user',
        loadComponent: () => import('../app/features/account/authorize-user.component'),
      },
      {
        path: 'brand-kit',
        loadComponent: () => import('../app/features/account/brand-kit.component'),
      },
      {
        path: 'logout',
        loadComponent: () => import('../app/features/account/logout.component'),
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
];
